import React from "react";
import { useNavigate } from "react-router-dom";

export default function SubscriptionCancel() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className="max-w-md w-full card p-8 text-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-8 h-8 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>

                <h1 className="text-xl font-bold text-gray-900 mb-2">
                    Checkout Canceled
                </h1>
                <p className="text-gray-500 mb-8">
                    No worries! You can subscribe whenever you're ready.
                </p>

                <div className="space-y-3">
                    <button
                        onClick={() => navigate("/subscribe")}
                        className="w-full btn-primary"
                    >
                        Try Again
                    </button>
                    <button
                        onClick={() => navigate("/")}
                        className="w-full text-gray-500 hover:text-gray-900 transition-colors text-sm py-2"
                    >
                        Return to Home
                    </button>
                </div>
            </div>
        </div>
    );
}
